import React, { useEffect, useState, useCallback } from 'react';
import * as Boxes from '../../components/styles/blocks';
import * as vars from '../../components/styles/variables';
import Icon from '../../components/global/BrandIcon';
import RequestService from '../../services/RequestService';
import PiratesService from '../../services/api/PiratesService';
import { useProfile } from '../providers/profile/index';
import Paragraph from '../../components/global/text/Paragraph';
import Button from '../../components/global/button';
import RequestInitializer from '../../services/RequestInitializer';
import { useRouter } from 'next/router';

function ClaimBanner() {
  const { profile, holderPiratesIds } = useProfile();
  const router = useRouter();
  const [shouldShow, setShouldShow] = useState(false);
  const [settingsReq] = RequestInitializer.get(1);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => { return () => settingsReq.source.cancel("Component unmounted") }, []);

  const bannerAvailable = useCallback(async () => {
    /* Checking if the current route is /claim. If it is, it will return and not show the banner. */
    if (router.asPath.includes("/claim")) return;

    const [response, ,] = await settingsReq.get(
      `/accounts/${profile.metamaskAddress}/settings/find`.toLowerCase(),
      { name: "hide_claim_banner", value: "true" },
    );

    if (!response?.data) {
      const params = {
        token_id: holderPiratesIds,
        do_not_paginate: true,
      };
      const [pirates] = await PiratesService.get(params);
      if (pirates) {
        setShouldShow(pirates.filter(pirate => !pirate.flowClaimed).length);
      }
    }

  }, [profile, holderPiratesIds, router.asPath, settingsReq]);

  useEffect(() => {
    if(!global.claimEnabled) return;
    
    if (profile && holderPiratesIds.length) bannerAvailable();
  }, [holderPiratesIds, profile, bannerAvailable]);

  const onClick = async (action) => {
    setShouldShow(false);

    await RequestService.post(
      `/accounts/${profile.metamaskAddress}/settings`.toLowerCase(),
      { name: "hide_claim_banner", value: "true" },
    );    
    
    /**
     * No matter that the request failed. 
     * If user was able to click on claim, it should be disappear and go to claim page.
     **/
    if(action !== 'close'){
      if (action === 'claim') router.push("/claim");
    }
  };

  return (
    <Boxes.AbsoluteBlock
      position="fixed"
      {...Boxes.positionProps.bottom}
      zIndex="3000"
      bColor={vars.colors.fuchsia}
      width="100%"
      transition="transform 500ms ease"
      transform={`translateY(${shouldShow ? 0 : 102 }%)`}
    >
      <Boxes.Flex ai="center" jc="center" wrap="wrap">
        <Paragraph
          color={vars.colorPallet.piratePink}
          fontSize={vars.fontSizes.mediumText}
          mediumFontSize={vars.fontSizes.semiNormal}
          align="center"
          margin="10px"
          bold
        >
          YOU HAVE CLAIMABLE FLOW PIRATES
        </Paragraph>
        <Button schema="softPink" bRadius="5px" onClick={() => onClick('claim')} margin="10px 15px" styles={{fontSize: "14px", padding: "8px 20px"}}>
          <Boxes.Flex ai="center">
            CLAIM NOW
          </Boxes.Flex>
        </Button>
      </Boxes.Flex>
      <Boxes.AbsoluteBlock
        cursor="pointer"
        marginR="10px"
        color={vars.colorPallet.piratePink}
        onClick={() => onClick('close')}
        {...Boxes.positionProps.rightCenter}
      >
        <Icon fontSize="30px" name="times-circle-o" fontSizeMd="22px"/>
      </Boxes.AbsoluteBlock>
    </Boxes.AbsoluteBlock>
  )
}


export default ClaimBanner;